<script>
export default {
  name: "mergeInto",
  inject: ["modalData"],
  data() {
    return {
      form: {}
    };
  }
};
</script>

<template>
  <!-- 整体表单  -->
  <el-form ref="form" :model="form" label-width="100px">
    <el-form-item
      label="请选择团队"
      prop="userPhone"
      :rules="[{ required: true, trigger: 'blur' }]"
    >
      <el-select
        v-model="form.status"
        placeholder="请选择并并入一级团队"
        clearable
        filterable
      >
        <el-option label="正常" :value="0"></el-option>
        <el-option label="冻结" :value="1"></el-option>
        <el-option label="锁定" :value="2"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<style scoped lang="scss"></style>
